import {
  CheckCircleOutlined,
  CheckOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { connect } from 'dva';
import React from 'react';
import styles from './style.less';

const List = ({
  steps,
  testConnectionTypes,
  protectionLevel,
  testCloudApis,
  cloudAccountProvider,
}) => {
  //  * if protectionLevel is advanced then show all steps and if protectionLevel is basic then show first 3 steps only
  let stepsToRender = protectionLevel === 'advanced' ? steps : steps.slice(0, 3);
  const isGCPAccount = cloudAccountProvider.toLowerCase() === 'gcp';
  const isAWSAccount = cloudAccountProvider.toLowerCase() === 'aws';
  const isAzureAccount = cloudAccountProvider.toLowerCase() === 'azure';

  const handleReTestConnections = () => {
    testCloudApis();
  };

  const isAnyTestLoading = () =>
    testConnectionTypes &&
    Object.keys(testConnectionTypes).some(key => testConnectionTypes?.[key]?.loading === true);

  const isAllTestPassed = () =>
    testConnectionTypes &&
    Object.keys(testConnectionTypes).every(key => testConnectionTypes?.[key]?.status === 200);

  const disabledReTestBtn = () => {
    if (isAnyTestLoading()) {
      // * if any test is loading then don't show retest button
      return true;
    } else if (isAllTestPassed()) {
      // * if all tests are passed then don't show retest button
      return true;
    } else {
      // * if any test is failed then show retest button
      return false;
    }
  };

  return (
    <div className={styles.listContainer}>
      <div className={styles.listInner}>
        {stepsToRender.map(step => {
          const shouldRender =
            ((isGCPAccount || isAzureAccount) && step.key !== 'eagleEye') || isAWSAccount;
          if (shouldRender) {
            return (
              <div className={styles.listItem}>
                <p className={styles.listText}>{step.name}</p>
                {/* // TODO :: following condition should be tested for all cases */}
                <Tooltip
                  title={
                    testConnectionTypes?.[step.key]?.loading
                      ? 'Loading'
                      : testConnectionTypes?.[step.key]?.message
                  }
                >
                  {testConnectionTypes?.[step.key]?.loading === false &&
                  testConnectionTypes?.[step.key]?.status !== 200 ? (
                    <InfoCircleOutlined
                      style={{ color: '#E94141', fontSize: '1.5rem', margin: '1rem 0' }}
                    />
                  ) : testConnectionTypes?.[step.key]?.loading === false &&
                    testConnectionTypes?.[step.key]?.status === 200 ? (
                    <CheckCircleOutlined
                      style={{ color: '#11CD87', fontSize: '1.5rem', margin: '1rem 0' }}
                    />
                  ) : (
                    <LoadingOutlined style={{ fontSize: '1.5rem', margin: '1rem 0' }} />
                  )}
                </Tooltip>
              </div>
            );
          }
          return null;
        })}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginTop: '1.5rem',
        }}
      >
        <Button
          disabled={disabledReTestBtn()}
          icon={<ReloadOutlined />}
          onClick={handleReTestConnections}
        >
          Re-test
        </Button>
      </div>
    </div>
  );
};

export default connect(({ cloudAccount }) => ({
  testConnectionTypes: cloudAccount.testConnectionTypes,
}))(List);
